import { AfterViewInit, Component, OnInit, ViewChild } from '@angular/core';
import { ClaimTypeEnvelope } from '../../../../models/net/envelope/claim-type-envelope';
import { AppService } from '../../../../services/app.service';
import { ActivatedRoute } from '@angular/router';
import { Location } from '@angular/common';
import { ClaimTypeService } from '../../../../services/identity/claim-types/claim-type.service';
import { EditorComponent } from '../../../base/editor/editor.component';
import { HistoryComponent } from '../../../fragments/history/history.component';

@Component({
    selector: 'app-claim-type',
    templateUrl: './claim-type.component.html',
    styleUrls: ['./claim-type.component.css', '../../../../app.component.css']
})

export class ClaimTypeComponent extends EditorComponent implements AfterViewInit {

    @ViewChild("appHistory") appHistory!: HistoryComponent;

    public constructor(public override appService: AppService,
                       public override itemService: ClaimTypeService,
                       public override route: ActivatedRoute,
                       public override location: Location) {

        super(appService, itemService, route, location, "claimtype", "claimtypes");
    }

    public override handleEditMode = (): void => {

        this.appService.navigateTo("claimtype/" + this.itemId.toString(), "");
    }

    public override initializeEnvelope = (envelope: ClaimTypeEnvelope | null): void => {

        super.initializeEnvelope(envelope);

        this.itemEnvelope = new ClaimTypeEnvelope(envelope);
        this.itemEnvelopeSnapshot = this.appService.cloneObject(this.itemEnvelope);
    }

    //public onTabChange(event: MatTabChangeEvent) {

    //    if (event.index == 0 && !this.isRevisionListLoaded) {

    //    }
    //}

    public ngAfterViewInit() {

        this.appHistory.searchRevisions();
    }
}
